import * as React from 'react'
import { BPMChart } from '../../../../components/Chart'
import { BPMAnalyticsAPI } from '../../../../api'
import { GroupByType } from '../../../../components/GroupByType'

export const ViewsChart: React.FunctionComponent = ({ }) => {
    const [groupBy, setGroupBy] = React.useState<string>('name')
    const toolbarItems = GroupByType([
        { val: 'name', display: 'Curated Set' },
        { val: 'category_name', display: 'Category' },
        { val: 'curator', display: 'Curator' }], groupBy, (selected) => {
            setGroupBy(selected!)
        }, false)
    return (
        <BPMChart title='Top Views' subTitle={'By ' + (groupBy == 'name' ? 'Curated Set' : groupBy == 'curator' ? 'Curator' : 'Category')} type='tree'
            onRequestLoad={(options, signal) => {
                return BPMAnalyticsAPI.get<any>(`curated/views`, options, signal)
            }} additionalParams={{ groupBy: groupBy }} toolBarItems={() => toolbarItems}
            allowedTypes={['spline', 'bar', 'doughnut', 'pie', 'tree']}
            series={{
                name: groupBy == 'name' ? 'Curated Set' : groupBy == 'curator' ? 'Curator' : 'Category', valueField: 'count', argumentField: groupBy,
                smallValuesGrouping: { topCount: 10, mode: 'topN' }
            }}>
        </BPMChart>
    )
}


// WEBPACK FOOTER //
// ./src/pages/Statistics/Curated/charts/ViewsChart.tsx